export enum ColumnType {
    Date,
    Time,
    LabelValue,
    Currency,
    DateTime,
}
